import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import Typography from '@mui/material/Box';
import { MobileNavItem } from './styles';

const MobileFeaturedContent = ({ description, image, link }) => {
  const linkObj = link && buildLinkObj(link);
  const featuredImg = image && buildImageSrc(image, 250, 5, 3);

  return (
    <MobileNavItem component="a" key={linkObj.href} href={linkObj.href} rel={getRel(linkObj)}>
      <Typography variant="body1" pb={1}>
        {description}
      </Typography>
      <img src={featuredImg} alt={description} />
    </MobileNavItem>
  );
};

export default MobileFeaturedContent;
